import React, { useEffect, useState } from "react";
import { Routes, useLocation } from "react-router-dom";
import LoadingBar from "react-top-loading-bar";

const CustomSwitch = ({ children }) => {
  const [prevLoc, setPrevLoc] = useState("");
  const location = useLocation();
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    setPrevLoc(location.pathname);
    setProgress(100);
    if (location.pathname === prevLoc) {
      setPrevLoc(""); //To fix same path infinite progress bar loading
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  useEffect(() => {
    setProgress(100);
  }, [prevLoc]);

  return (
    <>
      {!!progress && (
        <LoadingBar
        //   color="#1976d2"
        // color="#121212"
        color="#ffff"
          progress={progress}
          onLoaderFinished={() => setProgress(0)}
        />
      )}
      <Routes>{children}</Routes>
    </>
  );
};

export default CustomSwitch;
